import { Grid2 as Grid, Card, CardContent, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)(({ theme }) => ({
    textDecoration: "none",
    color: "black",
    "&:hover": {
        color: theme.palette.primary.main,
    },
}));

export const ComingSoonOverlay = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
    transition: 'background-color 0.3s',
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
    },
}));

export const ComingSoonText = styled(Typography)(({ theme }) => ({
    cursor: "default",
    opacity: 0,
    transition: 'opacity 0.3s',
    '.MuiCard-root:hover &': {
        opacity: 1,
    },
    '.MuiPaper-root:hover &': {
        opacity: 1,
    },
}));

interface LinkItem {
    name: string;
    path: string;
}

export interface CategorieItem {
    title: string;
    isComingSoon?: boolean;
    links: LinkItem[];
}

interface TablePageProps {
    categories: CategorieItem[];
}
const LinkRoutes = ({ categories }: TablePageProps) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ flexGrow: 1, padding: 3 }}>
            <Grid container spacing={3}>
                {categories.map((category, index) => (
                    <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                        <Card sx={{ height: "100%", position: 'relative' }}>
                            {category.isComingSoon && (
                                <ComingSoonOverlay>
                                    <ComingSoonText variant="h5">{t("data.comingSoon")}</ComingSoonText>
                                </ComingSoonOverlay>
                            )}
                            <CardContent sx={{ opacity: category.isComingSoon ? 0.4 : 1 }}>
                                <Typography variant="h6" gutterBottom>
                                    {category.title}
                                </Typography>
                                {category.links.map((link, linkIndex) => (
                                    <StyledLink to={link.path} key={linkIndex}>
                                        <Typography
                                            variant="subtitle1"
                                            gutterBottom
                                        >
                                            {link.name}
                                        </Typography>
                                    </StyledLink>
                                ))}
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default LinkRoutes;
